import { extendTailwindMerge } from "tailwind-merge";
import resolveConfig from "tailwindcss/resolveConfig";

import tailwindConfig from "./tailwind.config";

const customTailwindTheme = resolveConfig(tailwindConfig).theme;

const getToken = (
  tokenName: Exclude<keyof typeof customTailwindTheme, "extend">,
) =>
  Object.keys(customTailwindTheme[tokenName]).filter(
    (key) => key !== "DEFAULT",
  );

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: getToken("fontSize") }],
    },
  },
});

export default twMerge;
